export enum AiDialogType {
  Deals = "deals",
  Agents = "agents",
  Sessions = "sessions",
  AgentChat = "agent_chat",
  Settings = "settings",
}

export enum SenderType {
  User = "user",
  Agent = "agent",
}

export enum AgentVisibilityType {
  User = "user",
  Client = "client",
}

export enum AgentFeatureType {
  CommandBarAgentSearch = "command_bar_agent_search",
}
